import React from 'react';
import PropTypes from 'prop-types';
import Poster from './Poster';

const PosterList = (props) => {
  let posters = [];

  props.data.forEach((element, idx) => {
    posters.push(
      <Poster 
        data={element} 
        onViewClick={props.onViewClick} 
        onEditClick={props.onEditClick} 
        onDeleteClick={props.onDeleteClick} 
        key={element.id} />
    );
  });


  return (
    <div className="row" >
      {posters}
    </div>
  );
};

PosterList.propTypes = {
  data: PropTypes.array.isRequired,
};

export default PosterList;
